import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function photoValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;

        // Check if value is null or empty
        if (!value || value.trim() === '') {
            return { required: true };
        }

        // Check if value is base64 or URL
        const isBase64 = value.startsWith('data:image/');
        const isUrl = value.startsWith('http') || value.startsWith('/');

        if (!isBase64 && !isUrl) {
            return { invalidPhoto: true };
        }

        return null; // Valid photo
    };
}